module.exports = __webpack_public_path__ + "static/media/css.71837401.png";